/**
 * Unified Logs Page
 *
 * Combines Auth Events and Activity Logs into a single tabbed view.
 */

import { useSearchParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { AuthEventsContent } from '@/client/modules/auth-events/pages/AuthEventsPage'
import { ActivityLogsContent } from '@/client/modules/activity-logs/pages/ActivityLogsPage'
import { Shield, Activity } from 'lucide-react'

export function LogsPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get('tab') || 'auth'

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true })
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Logs</h1>
        <p className="text-muted-foreground">
          Authentication events and WordPress activity across all sites
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="auth" className="flex items-center gap-2">
            <Shield className="h-4 w-4" />
            Auth Events
          </TabsTrigger>
          <TabsTrigger value="activity" className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Activity
          </TabsTrigger>
        </TabsList>
        <TabsContent value="auth" className="mt-6">
          <AuthEventsContent />
        </TabsContent>
        <TabsContent value="activity" className="mt-6">
          <ActivityLogsContent />
        </TabsContent>
      </Tabs>
    </div>
  )
}
